import { ToastContainer, toast, Slide } from 'react-toastify';

import { useIsDesktop } from '@/hooks/useIsDesktop';

const ToasterContainer = () => {
  const { isDesktop } = useIsDesktop();

  return (
    <ToastContainer
      enableMultiContainer
      hideProgressBar
      containerId="global"
      position={
        isDesktop ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_LEFT
      }
      transition={Slide}
    />
  );
};

export default ToasterContainer;
